import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { getContratanteColectivoById, createContratanteColectivo, updateContratanteColectivo } from '../../../services/supabase/contratantesColectivosService';

export default function ContratantesColectivosForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = Boolean(id);

  const [form, setForm] = useState({
    tipo: '',
    nombre_razon_social: '',
    rut: '',
    giro: '',
    direccion: '',
    telefono: '',
    email: '',
    metadata: ''
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      try {
        const data = await getContratanteColectivoById(id);
        setForm({
          tipo: data?.tipo || '',
          nombre_razon_social: data?.nombre_razon_social || '',
          rut: data?.rut || '',
          giro: data?.giro || '',
          direccion: data?.direccion || '',
          telefono: data?.telefono || '',
          email: data?.email || '',
          metadata: data?.metadata ? JSON.stringify(data.metadata, null, 2) : ''
        });
      } catch (e) {
        console.error('Error cargando contratante', e);
      }
    };
    load();
  }, [id]);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handleSelect = (val) => setForm(prev => ({ ...prev, tipo: val }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validar JSON de metadata
    let metadataObj = null;
    if (form.metadata && form.metadata.trim()) {
      try {
        metadataObj = JSON.parse(form.metadata);
      } catch {
        alert('El JSON de metadata no es válido');
        return;
      }
    }
    const payload = {
      tipo: form.tipo,
      nombre_razon_social: form.nombre_razon_social,
      rut: form.rut || null,
      giro: form.giro || null,
      direccion: form.direccion || null,
      telefono: form.telefono || null,
      email: form.email || null,
      metadata: metadataObj
    };

    try {
      setSaving(true);
      if (isEditing) {
        await updateContratanteColectivo(id, payload);
      } else {
        await createContratanteColectivo(payload);
      }
      navigate('/product_config/contratantes');
    } catch (e) {
      console.error('Error guardando contratante', e);
      alert('Error guardando contratante');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">
          {isEditing ? 'Editar Contratante Colectivo' : 'Nuevo Contratante Colectivo'}
        </h1>
        <p className="text-gray-600">
          {isEditing ? 'Modifica los datos del contratante' : 'Crea un nuevo contratante colectivo'}
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Información</CardTitle>
        </CardHeader>
        <CardContent className="p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Tipo *</Label>
                <Select value={form.tipo} onValueChange={handleSelect}>
                  <SelectTrigger>
                    <SelectValue placeholder="Selecciona tipo" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="empresa">Empresa</SelectItem>
                    <SelectItem value="persona">Persona</SelectItem>
                    <SelectItem value="broker">Broker</SelectItem>
                    <SelectItem value="otro">Otro</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Razón Social *</Label>
                <Input name="nombre_razon_social" value={form.nombre_razon_social} onChange={handleChange} />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <Label>RUT</Label>
                <Input name="rut" value={form.rut} onChange={handleChange} />
              </div>
              <div>
                <Label>Giro</Label>
                <Input name="giro" value={form.giro} onChange={handleChange} />
              </div>
              <div>
                <Label>Teléfono</Label>
                <Input name="telefono" value={form.telefono} onChange={handleChange} />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label>Dirección</Label>
                <Input name="direccion" value={form.direccion} onChange={handleChange} />
              </div>
              <div>
                <Label>Email</Label>
                <Input name="email" value={form.email} onChange={handleChange} />
              </div>
            </div>

            <div>
              <Label>Metadata (JSON)</Label>
              <textarea
                className="w-full border rounded p-2 text-sm"
                rows={6}
                name="metadata"
                value={form.metadata}
                onChange={handleChange}
                placeholder='{"observaciones":"texto","config":{"ejemplo":true}}'
              />
            </div>

            <div className="flex justify-between pt-6">
              <Button type="button" variant="outline" onClick={() => navigate('/product_config/contratantes')}>
                Volver
              </Button>
              <Button type="submit" disabled={saving}>
                {saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear')}
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}